module.exports = __webpack_public_path__ + "static/media/1.e7708b26.jpg";